import styled, { css } from 'styled-components';
import colors from '../../../../helpers/colors';
import fonts from '../../../../helpers/fonts';
import spacing from '../../../../helpers/spacing';

export const DesktopLabelWrapper = styled.div`
  ${fonts.paragraph};
  & {
    color: inherit;
  }
  width: 100%;
  // Explicitly setting the height here so that alignment matches if text missing
  height: ${spacing(6)};
  display: flex;
  justify-content: center;
  align-items: center;
`;

const CommonButtonStyle = css`
  width: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  border: none;
`;

export const DesktopPanelButtonStyle = styled.button<{ isSelected: boolean }>`
  ${CommonButtonStyle}

  ${({ isSelected }) =>
    isSelected
      ? css`
          color: ${colors.neutral08};
          background: ${colors.core02};
          cursor: default;
        `
      : css`
          color: ${colors.core01};
          background: none;
          cursor: pointer;
        `}
    
  &:hover {
    background: ${colors.neutral06};
  }
  &:focus {
    outline: solid ${colors.core01} 2px;
    z-index: 2;
  }
  &:focus-visible {
    outline: solid ${colors.neutral05} 4px;
    z-index: 2;
  }
`;
